import { render, staticRenderFns } from "./studentRecord.vue?vue&type=template&id=1a4973a5&scoped=true&"
import script from "./studentRecord.vue?vue&type=script&lang=js&"
export * from "./studentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4973a5",
  null
  
)

export default component.exports